export default __webpack_public_path__ + "static/logo-f6f004ea3d3d0ebe004f2a69551a75f6ae69c2105c88244e65931ab414077d64.png";